import React from "react";
import { Button, Modal } from "antd";
import "./function.css";
import { Power } from "../../api";
import { useGlobal } from "../../global/user";

export default function Function8({ data, machineInfo }) {
  const { user } = useGlobal();
  const { IP, port, name } = machineInfo;
  const switchOnConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認開啟電源 ${name} `,
      onOk: async () => {
        await Power.PowerOn(IP, port, user.name);
      },
    });
  const switchOffConfirm = () =>
    Modal.confirm({
      title: `確認執行`,
      content: `確認關閉電源 ${name} `,
      onOk: async () => {
        await Power.PowerOff(IP, port, user.name);
      },
    });
  return (
    <React.Fragment>
      <td>
        <div className="d-flex justify-content-center my-1">
          {user.class >= process.env.REACT_APP_EDITOR_CALSS_LV && (
            <div>
              <Button style={{ width: 80 }} className="mr-3" onClick={switchOnConfirm} disabled={data.status === -1}>
                ON
              </Button>
              <Button style={{ width: 80 }} onClick={switchOffConfirm} disabled={data.status === -1}>
                OFF
              </Button>
            </div>
          )}
        </div>
      </td>
    </React.Fragment>
  );
}
